export const OVERRIDE_KEYS = {
  TOTAL_VOLUME: 'totalVolume',
  AUTOMATION_CONFIG: 'automationConfig',
  CYCLE_AUTOMATION_CONFIG: 'cycleAutomationConfig'
};

export const OPTIMIZER_PRESETS = [
  {
    label: 'Smooth Ops',
    value: 'smooth_ops',
    description: 'Balanced priority ordering: Quality > Safety Factor > Labor Minimization > Setpoint Compliance',
    enabled: true,
    default: true
  },
  {
    label: 'Min Labor',
    value: 'min_labor',
    description:
      'Minimize total labor — promotes Labor Minimization above Quality and Safety Factor while preserving throughput',
    enabled: true,
    default: false
  },
  {
    label: 'Prioritize WIP',
    value: 'prioritize_wip',
    description:
      'Prioritize quality and induct efficiency — elevates Induct Priority and Quality above volume objectives, with Safety Factor next',
    enabled: true,
    default: false
  }
];

export const ALERT_BG_WARNING = '#fcf2be';

export const ALERT_MESSAGES = {
  NOT_RUN: 'Flow Plan has not been run.',
  GENERATING: 'Flow Plan is being generated. Please wait...',
  AWAITING_APPROVAL: 'Flow Plan has been completed and is awaiting approval.',
  APPROVED: 'Flow Plan has been approved.',
  REJECTED: 'Flow Plan was rejected. You can modify inputs and re-run.',
  CREATION_FAILED: 'Plan creation failed.'
};

export const ERROR_MESSAGES = {
  CREATE_PLAN: 'Failed to create plan',
  APPROVE_PLAN: 'Failed to approve plan',
  REJECT_PLAN: 'Failed to reject plan',
  POLL_TIMEOUT: 'Plan creation timed out. Please try again.',
  POLL_ERROR: 'Error polling plan status'
};
